import React from 'react'
import './Dashboard.css'
import team from './brainstorming.svg'
import startup from './startup.svg'
import problem from './data_arranging.svg'
import Projects from '../../components/Projects/Projects'

function Dashboard(props) {


    const handleEmptyClick = event => {
        alert("Registrierung muss noch implementiert werden.")
    }

    return (
        <>
            <div className="rail-container">
                <div className="card" onClick={handleEmptyClick}>
                    <h3>Bist Du ein lokales Unternehmen, ein Verein oder eine Institution die
                        durch die Corona Krise mit Problemen zu kämpfen hat?</h3>
                    <p>Dann teile deine Story mit einer Community von ambitionierten kreativen Köpfen aus deiner Region. Hier hören wir Dir zu und bewältigen gemeinsam die Krise!
                             Niemand muss alleine durch. Profitiere von Synergien mit anderen Unternehmen und lokalpionieren in deiner Region. </p>
                    <img className="rail-img" src={problem}></img>
                    <h4> Ich möchte mein Anliegen teilen !</h4>
                </div>
                <div className="card" onClick={handleEmptyClick}>
                    <h3>Bist Du ein kreativer Kopf, Meister Hacker, Marketing Guru, Zahlengenie oder Querdenker und willst trotz Home Office und Quarantäne  in deiner Region etwas Großes bewirken?</h3>
                    <p>Dann tritt jetzt der Community bei und arbeite im Team mit Gleichgesinnten an echten Problemstellungen von Unternehmen, Vereinen und Institutionen in deiner Region. Dein Engagement ist gefragter als je zuvor! Werde lokalpionier! </p>
                    <img className="rail-img" src={team}></img>
                    <h4> Ich möchte die Region verändern !</h4>

                </div>
                <div className="card" onClick={handleEmptyClick}>

                    <h3>Möchtest Du Dich motivieren und von bereits erfolgreichen Projekten mit lokalpionieren inspirieren lassen?</h3>
                    <p>Hier findest du inspirierende Geschichten die durch lokalpioniere geschrieben wurden, von Zusammenhalt, Gemeinschaft, Teamwork und konstruktiver und kreativer Lösung verschiedenster Probleme die durch Corona entstanden sind. Vielleicht findest du ja etwas, was dich auch direkt betrifft darunter.</p>
                    <img className="rail-img" src={startup}></img>

                    <h4> Ich möchte inspiriert werden !</h4>
                </div>



            </div>

            <div className="projects-container">
                <h1>Aktuelle Projekte in <span className="region-caption">Ingolstadt</span></h1>
                <Projects></Projects>
            </div>
        </>
    )
}

export default Dashboard;